export default __webpack_public_path__ + "static/media/default-fish-right.png";